    <ui-table
      [rowHighlightCondition]="highlightRow"
      [data]="consistencyIssues"
      [highlightStyles]="'highlight-class'"
      [templates]="[
          {
            title: '',
            template: consistencyCheckType,
            colClass: 'claim-consistencies-table-column claim-consistencies-table-nobreaks-column claim-consistencies-table-checkType-column'
        },
        {
            title: 'translate.consistencyIssues.category',
            template: category,
            colClass: 'claim-consistencies-table-column claim-consistencies-table-nobreaks-column'
        }, 
        {
          title: 'translate.consistencyIssues.issueDescription',
          template: issueDescription,
          colClass: 'claim-consistencies-table-column'
        },  
        {
            title: 'translate.consistencyIssues.action',
            template: consistencyReasonAction,
            colClass: 'claim-consistencies-table-column claim-consistencies-table-actions-column'
        }
      ]"
    ></ui-table>

        <ng-template #category let-row="row">
          <span *ngIf="row.category"
            class="consistency-issues-category-pill"
            [ngClass]="getCategoryClass(row.category)">
            {{ "translate.consistencyIssues.category." + row.category | translate }}
          </span>
        </ng-template>
    <ng-template #issueDescription let-row="row">
            <span *ngIf="row.reason">{{ row.reason }}</span>
            <!-- Explanation (Expandable) -->
            <ng-container *ngIf="row.explanation?.trim()">
              <span *ngIf="!row._isExplanationExpanded">
                <br />
                <a href="#" (click)="toggleExplanation(row, $event)">Show more</a>
              </span>

              <span *ngIf="row._isExplanationExpanded">
                <br />
                {{ row.explanation }}
                <a href="#" (click)="toggleExplanation(row, $event)">Show less</a>
              </span>
            </ng-container>
    </ng-template>
    
    <ng-template #consistencyCheckType let-row="row">
      <span>
            <i  style="width: 30px; margin: 0 10px 5px 10px;" [class]='row.icon'
            [tooltip]="row.tooltip | translate">
            </i>
      </span>
    </ng-template>
        <ng-template #consistencyReasonAction let-row="row">
            <a (click)="viewConsistencyIssue(row)">
              <i [ngClass]="row.showCrossedEyeIcon ? 'fas fa-eye-slash crossed-eye-background' : 'fas fa-eye icon-view'" tooltip="{{ 'translate.general.view' | translate}}">
              </i>
            </a>
            <ng-container *ngIf="row.consistencyCheckType !== 'ASSOC_IMAGE'">
        <span class="action-divider">|</span>
        <a (click)="removeConsistencyIssue(row)" [class.disabled]="disableActions">
          <i [class.disabled]="disableActions" class="fa-solid fa-xmark" tooltip="{{ 'translate.general.remove' | translate  }}"></i>
        </a>
        <ng-container *ngIf="row.convertible">
          <span class="action-divider">|</span>
          <a (click)="markAsConsistent(row)" [class.disabled]="disableActions">
            <i [class.disabled]="disableActions" class="fas fa-check" tooltip="{{ 'translate.general.mark-as-consistent' | translate }}"></i></a>
            </ng-container>
        </ng-container>
        </ng-template>